import { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { MdFlightTakeoff, MdFlightLand } from 'react-icons/md';
import TwSlider from '../../../../TwSlider';
import formatMinutesToTime from '../../../../../helpers/formatters/formatMinutesToTime';
import { MIN_MINUTES, MAX_MINUTES, isFullDayRange } from '../../../../../helpers/flightTimeWindow';

const TimeSlider = memo(({ type, value, onChangeCommitted, isReturn }) => {
  const [displayValue, setDisplayValue] = useState(value);

  // Sync local display state when parent value changes (e.g. on clear)
  useEffect(() => {
    setDisplayValue(value);
  }, [value[0], value[1]]); // oxlint-disable-line react/exhaustive-deps

  const handleDisplayChange = (event, newValue) => {
    setDisplayValue(newValue);
  };

  const isDeparture = type === 'departure';
  const Icon = isDeparture ? MdFlightTakeoff : MdFlightLand;
  const label = isDeparture ? 'Departure' : 'Arrival';
  const anytime = isFullDayRange(displayValue[0], displayValue[1]);
  const mirrorStyle = isReturn ? { transform: 'scaleX(-1)' } : undefined;

  return (
    <div className="mb-3">
      <div className="flex items-center mb-2">
        <Icon className="text-gray-500 text-xl mr-2" style={mirrorStyle} />
        <span className="text-sm text-gray-700">
          {label}
          {' · '}
          {anytime
            ? 'Anytime'
            : `${formatMinutesToTime(displayValue[0])} - ${formatMinutesToTime(displayValue[1])}`}
        </span>
      </div>
      <div className="px-2">
        <TwSlider
          value={displayValue}
          onChange={handleDisplayChange}
          onChangeCommitted={onChangeCommitted}
          min={MIN_MINUTES}
          max={MAX_MINUTES}
          step={15}
        />
      </div>
    </div>
  );
});

TimeSlider.displayName = 'TimeSlider';

TimeSlider.propTypes = {
  type: PropTypes.oneOf(['departure', 'arrival']).isRequired,
  value: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChangeCommitted: PropTypes.func.isRequired,
  isReturn: PropTypes.bool,
};

TimeSlider.defaultProps = {
  isReturn: false,
};

export default TimeSlider;
